<template>
  <div class="contact-cta">
    <div class="contact-cta-text">
      <h3>{{ heading }}</h3>
      <p>{{ description }}</p>
    </div>
    <div class="cta-actions">
      <a
        :href="instagramUrl"
        class="btn-outline-white"
        target="_blank"
        rel="noopener"
        >{{ instagramLabel }}</a
      >
      <a :href="emailHref" class="btn-filled-white">{{ emailLabel }}</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomerCareCta",
  props: {
    heading: {
      type: String,
      default: "Still have a question?",
    },
    description: {
      type: String,
      default:
        "Our team is ready to help. Reach out and we'll get back to you within 24 hours.",
    },
    instagramUrl: {
      type: String,
      default: "https://www.instagram.com/hooliganseyewear/",
    },
    instagramLabel: {
      type: String,
      default: "DM on Instagram",
    },
    emailHref: {
      type: String,
      default: "mailto:support@hooliganseyewear.com",
    },
    emailLabel: {
      type: String,
      default: "Email us",
    },
  },
};
</script>
